module.exports = __webpack_public_path__ + "static/media/logo-sq.b8dc0fea.svg";